import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=74fb82aa&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MainView.vue?vue&type=style&index=0&id=74fb82aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb82aa",
  null
  
)

export default component.exports